import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
// eslint-disable-next-line import/named

import { DetailCouncil } from 'features/CouncilPrequalification/pages';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function DetailCouncilPage() {
  const { t } = useTranslation();
  return (
    <LayoutProvider>
      <Layout>
        <>
          <Can do="read" on="council">
            <DetailCouncil />
          </Can>
          <Can not do="read" on="council">
            <h4 className="text-red-500">{t('permission.forbid.read.projectProposalList')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default DetailCouncilPage;
